<script lang="ts" setup>
import { computed } from 'vue-demi'
import dayjs from 'dayjs'

import { DATE_FORMAT } from '/@src/constants'

export interface DateFormattedProps {
  /** Date in ISO format. */
  date: string
}

const props = defineProps<DateFormattedProps>()

const dateFormatted = computed(() => {
  const d = dayjs(props.date)
  if (!d.isValid()) return props.date
  return d.format(DATE_FORMAT)
})
</script>

<template>
  <span>{{ dateFormatted }}</span>
</template>

<style scoped>

</style>
